import mapiHandlers from './mapiHandlers';
const LOADED_SEARCH_EVENT = 'frontend-shell:loaded-search';
const CHANGE_DISPLAYED_ITINERARIES = 'frontend-shell:change-displayed-itineraries';
const NO_SEARCH_RESULTS = 'frontend-shell:no-search-results';
const RESULTS_PAGE_LOADING = 'frontend-shell:results-page-loading';
const CHEAPEST_ITINERARY_PRICE_KEY = 'cheapestItineraryPrice';
export const createSearchHandlers = of1Props => {
  const {
    trigger
  } = of1Props;
  const handleSearchLoaded = () => {
    trigger(LOADED_SEARCH_EVENT, false, true);
  };
  const handleDisplayedItinerariesChange = (actualPage = 1, cheapestItineraryPrice, itinerariesCounter) => {
    window.sessionStorage.setItem(CHEAPEST_ITINERARY_PRICE_KEY, cheapestItineraryPrice);
    trigger(CHANGE_DISPLAYED_ITINERARIES, actualPage, cheapestItineraryPrice, itinerariesCounter);
  };
  const handleNoSearchResults = () => {
    trigger(NO_SEARCH_RESULTS);
  };
  const handleLoadingResultsPage = () => {
    trigger(RESULTS_PAGE_LOADING);
  };
  return {
    handleSearchLoaded,
    handleDisplayedItinerariesChange,
    handleNoSearchResults,
    handleLoadingResultsPage,
    ...mapiHandlers(of1Props)
  };
};